var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userinfo"},[_c('app-header',{attrs:{"title":_vm.title}}),_c('form-entity',{staticClass:"form-edit",attrs:{"model":_vm.user,"rules":_vm.rules}},[_c('form-field',{attrs:{"prop":"nickName","default-focus":false,"options":{
        label: '用户昵称',
        readonly: true,
        placeholder: '用户昵称',
        type: 'text',
        required: true
      }}}),_c('form-field',{attrs:{"prop":"userId","default-focus":true,"options":{
        label: '用户ID',
        readonly: true,
        placeholder: '用户ID',
        type: 'text',
        required: true
      }}}),_c('form-field',{attrs:{"prop":"mobileNumber","options":{
        label: '手机号码',
        readonly: true,
        placeholder: '手机号码',
        type: 'tel',
        format: 'phone',
        required: true
      }}})],1),(!_vm.type)?_c('img',{staticClass:"qrcode",attrs:{"src":_vm.qrcode,"alt":""}}):_vm._e(),(!_vm.type)?_c('h5',[_vm._v("添加班主任微信，激活课程服务")]):_vm._e(),(_vm.type)?_c('img',{staticClass:"qrcode",attrs:{"src":_vm.popData.data.adviser.avatarUrl || '',"alt":""}}):_vm._e(),(_vm.type)?_c('h5',[_vm._v(_vm._s(_vm.popData.message))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }